import axios, { AxiosRequestConfig } from 'axios';

const AuthorizationHeaderName = 'Authorization';

type BearerAuth = `Bearer ${string}`;

const API = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
});

const verifyAuth = (req: AxiosRequestConfig) => {
  // @ts-ignore
  const authToken = req.headers?.common![AuthorizationHeaderName] as
    | BearerAuth
    | undefined;
  if (!authToken) {
    console.log(`Missing Authorization: Cannot ${req.method} ${req.url}`);
    return;
  }
  return req;
};

API.interceptors.request.use(verifyAuth);

export const setAccessToken = (token: string) => {
  const t: BearerAuth = `Bearer ${token}`;
  API.defaults.headers.common[AuthorizationHeaderName] = t;
};

export const getAccessToken = () =>
  API.defaults.headers.common[AuthorizationHeaderName];

export default API;
